/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAwsSsmAutomationExecutionJobs extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAwsSsmAutomationExecutionJobs");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAwsSsmAutomationExecutionJobs.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAwsSsmAutomationExecutionJobs>): BackgroundJobPayloadForAwsSsmAutomationExecutionJobs {
        let obj = Object.assign(new BackgroundJobPayloadForAwsSsmAutomationExecutionJobs(), model);
        BackgroundJobPayloadForAwsSsmAutomationExecutionJobs.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAwsSsmAutomationExecutionJobs>): BackgroundJobPayloadForAwsSsmAutomationExecutionJobs {
        if (!model) return null;
        return BackgroundJobPayloadForAwsSsmAutomationExecutionJobs.newInstance(<BackgroundJobPayloadForAwsSsmAutomationExecutionJobs> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAwsSsmAutomationExecutionJobs) {
        if (!obj) return;

        models.BackgroundJobPayloadForAwsSsmAutomationExecutionJobs.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAwsSsmAutomationExecutionJobs): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAwsSsmAutomationExecutionJobs.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Execution ID of the command document
     */
    automation_execution_id: string;

    /**
     * SSM job group document id
     */
    job_group_id: string;

}
